const InvoiceAutomationEvent = {
  fetchOne: 'invoice-automation/fetch-one'
}

export default InvoiceAutomationEvent
